var map = {
	"./marmoset-logo-grey.png": "./app/assets/images/marmoset-logo-grey.png",
	"./vimeo-logo-grey.png": "./app/assets/images/vimeo-logo-grey.png",
	"./youtube-logo-grey.png": "./app/assets/images/youtube-logo-grey.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./app/assets/images sync recursive ^\\.\\/.*\\-logo\\-grey\\.png$";